import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import ProductShowcase from "@/components/landing/ProductShowcase";
import Bestseller from "@/components/landing/Bestseller";
import HowItWorks from "@/components/landing/HowItWorks";
import Benefits from "@/components/landing/Benefits";
import Industries from "@/components/landing/Industries";
import Personalization from "@/components/landing/Personalization";
import Bulk from "@/components/landing/Bulk";
import ReputationService from "@/components/landing/ReputationService";
import MoreServices from "@/components/landing/MoreServices";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCta from "@/components/landing/FinalCta";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-brand-ink font-body" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <ProductShowcase />
        <Bestseller />
        <HowItWorks />
        <Benefits />
        <Industries />
        <Personalization />
        <Bulk />
        <ReputationService />
        <MoreServices />
        <Testimonials />
        <FAQ />
        <FinalCta />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
